// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

export const Alert = t.struct(
    {
        type: t.String,
        reference: t.String,
        message: t.String
    },
    'Alert'
);

export const getDefaultState = () => new Alert( {
    type: '',
    reference: '',
    message: ''
} );
